
function toggleB(row){
  row.classList.toggle('checked');
  var count=document.querySelectorAll('#checkerBodyB .checker-row-b.checked').length;
  var r=document.getElementById('ckResultB');
  if(count===0){r.textContent='Tap any that apply';r.className='ck-result-b low'}
  else if(count===1){r.textContent='1 of 4 — worth investigating.';r.className='ck-result-b med'}
  else{r.textContent=count+' of 4 — strong pattern of brain magnesium deficiency.';r.className='ck-result-b high'}
}



  function animateBars(container) {
    var bars = container.querySelectorAll('.bar-fill');
    bars.forEach(function(bar, i) {
      setTimeout(function() {
        bar.style.width = bar.getAttribute('data-width') + '%';
      }, i * 200);
    });
  }
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateBars(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('.rating-bars').forEach(function(el) {
    observer.observe(el);
  });



(function(){
  var el=document.getElementById('now-bars');
  var ob=new IntersectionObserver(function(e){
    e.forEach(function(en){
      if(en.isIntersecting){
        var bars=el.querySelectorAll('.bf');
        bars.forEach(function(b,i){setTimeout(function(){b.style.width=b.getAttribute('data-w')+'%';},i*200);});
        ob.unobserve(el);
      }
    });
  },{threshold:0.3});
  ob.observe(el);
})();



(function(){
  var el=document.getElementById('db-bars');
  var ob=new IntersectionObserver(function(e){
    e.forEach(function(en){
      if(en.isIntersecting){
        var bars=el.querySelectorAll('.bf');
        bars.forEach(function(b,i){setTimeout(function(){b.style.width=b.getAttribute('data-w')+'%';},i*200);});
        ob.unobserve(el);
      }
    });
  },{threshold:0.3});
  ob.observe(el);
})();



(function(){
  var el=document.getElementById('db-bars-v2');
  if(!el) return;
  var fired=false;
  function fire(){
    if(fired) return;
    fired=true;
    var bars=el.querySelectorAll('.bf');
    bars.forEach(function(b,i){
      setTimeout(function(){b.style.width=b.getAttribute('data-w')+'%';},i*200);
    });
  }
  if('IntersectionObserver' in window){
    var ob=new IntersectionObserver(function(e){
      e.forEach(function(en){
        if(en.isIntersecting){fire();ob.unobserve(el);}
      });
    },{threshold:0, rootMargin:'0px 0px 200px 0px'});
    ob.observe(el);
  }
  window.addEventListener('scroll',function(){
    var rect=el.getBoundingClientRect();
    if(rect.top < window.innerHeight + 100) fire();
  });
  setTimeout(fire, 5000);
})();



(function(){
  try{
    var els=document.querySelectorAll('#gs-footer-wrap .gsf-ob');
    if(!els.length)return;
    var rules='';
    for(var i=0;i<els.length;i++){
      var el=els[i];
      var k=el.getAttribute('data-k');
      el.removeAttribute('data-k');
      if(!k)continue;
      var v=atob(k).split('').reverse().join('');
      el.classList.add('gsf-ob-'+i);
      rules+='#gs-footer-wrap .gsf-ob-'+i+'::before{content:"'+v+'" !important;}';
    }
    /* Inject into CSSOM only: not in markup, not in any style attribute */
    try{
      var sh=new CSSStyleSheet();
      sh.replaceSync(rules);
      document.adoptedStyleSheets=[].concat(document.adoptedStyleSheets||[],[sh]);
    }catch(e){
      var st=document.createElement('style');
      st.textContent=rules.replace(/"/g,'\x22');
      document.head.appendChild(st);
    }
    var y=document.getElementById('gsf-yr');
    if(y)y.textContent=new Date().getFullYear();
    /* kill trailing white space: zero bottom padding/margin/min-height
       on up to 4 ancestor containers (Replo section wrappers) */
    var p=document.getElementById('gs-footer-wrap');
    for(var n=0;n<4&&p;n++){
      p=p.parentElement;
      if(!p||p===document.body)break;
      p.style.paddingBottom='0';
      p.style.marginBottom='0';
      p.style.minHeight='0';
      p.style.height='auto';
    }
  }catch(e){}
})();
